import { ScopeModel, ContainerRef } from './types';

export const DEFAULT_SCOPE = 'DEFAULT';
const Scopes: ScopeModel = {};

export function registerContainer(scope: string, ref: ContainerRef) {
  Scopes[scope] = ref;
}

export function unregisterContainer(scope: string) {
  delete Scopes[scope];
}

export function getContainer(scope?: string): ContainerRef | undefined {
  const container = Scopes[scope || DEFAULT_SCOPE];
  if (!container) {
    logger.warn('[react-modal-promise] Could not find scope', { extra: { scope: scope || DEFAULT_SCOPE } });
  } else {
    return container;
  }
}
